import { useQuery } from '@tcs/common/hooks/useQuery';

interface isEligibleAccountsProps {
  loading: boolean;
  isEligible: boolean | undefined;
}

export const useIsEligibleAccounts = (
  representativeCode?: string,
  options?: { enabled?: boolean }
): isEligibleAccountsProps => {
  const { data: isEligible, isLoading: loading } = useQuery<boolean, Error>(
    `/rss/generatedreports/eligible/${representativeCode}`,
    {
      ...options,
      enabled: !!representativeCode && (options?.enabled ?? true),
    }
  );

  return {
    loading,
    isEligible,
  };
};

export default useIsEligibleAccounts;
